import { User } from 'models/user';
import { Dashboard } from 'models/dashboard';
import { UserFromFaweb } from 'models/userFromFaweb';
import { api } from './client';
import { mergeUsersArray } from 'utils/users';

export async function getCurrentUser(): Promise<User> {
    const response = await api.get('/api/users/me');
    const user: User = response.data;
    return user;
}

async function getFsdbUsers(): Promise<User[]> {
    const response = await api.get('/api/users');
    return response.data.users;
}

async function getFawebUsersById(userIds: string[]): Promise<UserFromFaweb[]> {
    const response = await api.get(`/api/users/details?ids=${userIds.join(',')}`);
    return response.data.users;
}

export async function getAllUsers(): Promise<User[]> {
    const fsdbUsers = await getFsdbUsers();
    const fsdbUserIds = fsdbUsers.map((user) => user.id);
    const fawebUsers = await getFawebUsersById(fsdbUserIds);

    return mergeUsersArray(fsdbUsers, fawebUsers);
}

export async function getUser(userId: string): Promise<User> {
    const response = await api.get(`/api/users/${userId}`);
    return response.data;
}

export async function createUser(user: Partial<User>): Promise<User> {
    const { data: newUser } = await api.put(`/api/users/${user.id}`, user);
    return newUser;
}

export async function updateUser(userId: string, changes: Partial<User>): Promise<User> {
    const response = await api.patch(`/api/users/${userId}`, changes);
    return response.data;
}

export async function addUserToDashboard(userId: string, dashboardId: string): Promise<boolean> {
    const response = await api.put(`/api/users/${userId}/dashboards/${dashboardId}`);
    return response.status === 204;
}

export async function removeUserFromDashboard(userId: string, dashboardId: string): Promise<boolean> {
    const response = await api.delete(`/api/users/${userId}/dashboards/${dashboardId}`);
    return response.status === 204;
}

export async function getUserDashboards(userId: string): Promise<Dashboard[]> {
    const response = await api.get(`/api/users/${userId}/dashboards`);
    return response.data.dashboards;
}
